import { GridColDef } from '@mui/x-data-grid-premium'

const partNumber: GridColDef = {
	field: 'manufacturerNumber',
	hideable: false,
	headerName: 'Manufacturer Number',
	width: 200,
	sortable: false,
}

export default partNumber